'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSyncAction;

var _util = require('./util');

function createSyncAction(type, payloadCreator, metaCreator) {
  function noop(payload) {
    return payload;
  }

  return function () {
    var payload = (0, _util.isFunc)(payloadCreator) ? payloadCreator.apply(undefined, arguments) : noop(arguments.length <= 0 ? undefined : arguments[0]);
    var result = {
      payload: payload,
      type: type
    };

    if ((0, _util.isFunc)(metaCreator)) {
      result.meta = metaCreator.apply(undefined, arguments);
    }

    return result;
  };
}